// @generated source--
// scripts/generate-bits/file-generators/component-story-map.generator.ts

export const pipeStoryMap: {
  [name: string]: {
    path: string;
    tags: string[];
    internalOnly: boolean;
    stories: string[];
    description: string;
  };
} = {
  'bypass-security-trust-resource-url': {
    path: '',
    tags: ['url'],
    internalOnly: false,
    stories: ['default'],
    description: 'Marks a string URL as safe to load executable code from',
  },
  'compact-number': {
    path: '',
    tags: ['numeric'],
    internalOnly: false,
    stories: ['default'],
    description: 'Transforms a number into its compact form',
  },
  'freelancer-currency': {
    path: '',
    tags: ['numeric'],
    internalOnly: false,
    stories: ['default'],
    description: 'Formats amount given a currency code',
  },
  'date-range': {
    path: '',
    tags: ['date', 'time'],
    internalOnly: false,
    stories: ['default'],
    description:
      'Formats start and end timestamps as a readable date range, with optional format',
  },
  duration: {
    path: '',
    tags: ['time'],
    internalOnly: false,
    stories: ['default'],
    description: 'Converts milliseconds to a human readable format',
  },
  'dynamic-time': {
    path: '',
    tags: ['time'],
    internalOnly: false,
    stories: ['default'],
    description:
      'Shows timestamps under two days old as relative time, others as a compact date',
  },
  emoji: {
    path: '',
    tags: ['text'],
    internalOnly: false,
    stories: ['default'],
    description: 'Converts legacy and shorthand emojis to native emojis.',
  },
  'file-size': {
    path: '',
    tags: ['file'],
    internalOnly: false,
    stories: ['default'],
    description: 'Converts a file size to a human readable format',
  },
  'is-online': {
    path: '',
    tags: ['text'],
    internalOnly: false,
    stories: ['default'],
    description: 'Returns a boolean if the user is online',
  },
  location: {
    path: '',
    tags: ['location'],
    internalOnly: false,
    stories: ['default'],
    description: 'Get the location of the user',
  },
  'online-offline-status': {
    path: '',
    tags: ['text'],
    internalOnly: false,
    stories: ['default'],
    description: "Returns data about the user's online offline status",
  },
  'pascal-case': {
    path: '',
    tags: ['text'],
    internalOnly: false,
    stories: ['default'],
    description: 'Transforms a given string to PascalCase',
  },
  sanitise: {
    path: '',
    tags: ['text'],
    internalOnly: false,
    stories: ['default'],
    description: 'Replaces potentially dangerous characters with HTML entities',
  },
  'truncate-filename': {
    path: '',
    tags: ['file'],
    internalOnly: false,
    stories: ['default'],
    description:
      'Truncates a filename in the middle to a maximum length, keeping the extension',
  },
};
